export enum ConnectionState {
  ConnectState = 'ConnectState',
  ConnectToSlackState = 'ConnectToSlackState',
  ConnectionEditState = 'ConnectionEditState',
  ConnectionDisplayState = 'ConnectionDisplayState',
}
